/* import __COLOCATED_TEMPLATE__ from './final-u16-startlist-interface.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export default class HeatStartlistComponent extends Component 
{
	@service store;
	@service csv;
	@service sprintTools;
	
	@tracked semifinalsEvent;
	
	@tracked startTimeA;
	
	@tracked S1ClassGroup;
	@tracked S2ClassGroup;
	@tracked S3ClassGroup;
	
	@tracked AClassGroup;
	
	@tracked AAssignments;
	
	@action
	async semifinalsEventChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.semifinalsEvent = null;
		}
		else
		{
			var event = await this.store.findRecord('Event', browserEvent.target.value);
			this.semifinalsEvent = event;
		}
		
		if(this.semifinalsEvent?.id)
		{
			await this.sprintTools.fetchResultsForEvent(this.semifinalsEvent.id);
		}
		this.S1ClassGroup = null;
		this.S2ClassGroup = null;
		this.S3ClassGroup = null;
	}
	
	@action
	async S1ClassGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.S1ClassGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.S1ClassGroup = classGroup;
		}
		this.calculateHeatAssignments();
	}
	
	@action
	async S2ClassGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.S2ClassGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.S2ClassGroup = classGroup;
		}
		this.calculateHeatAssignments();
	}
	
	@action
	async S3ClassGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.S3ClassGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.S3ClassGroup = classGroup;
		}
		this.calculateHeatAssignments();
	}
	
	@action
	async AClassGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.AClassGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.startTimeA = dayjs(classGroup.startTime).format("HH:mm:ss");
			this.AClassGroup = classGroup;
		}
	}
	
	@action
	exportHeatStartListCSV()
	{
		// Check if assignments exist before exporting
		if (!this.AAssignments) {
			return;
		}

		var buildData = (assignments, classGroup, startTime) => {
			var data = [...this.sprintTools.getCSVHeaders()];
			for (const result of assignments) {
				data.push(this.sprintTools.buildCSVRow(result, classGroup, startTime, result.bib));
			}
			return data;
		};

		this.csv.export(buildData(this.AAssignments, this.AClassGroup, this.startTimeA), {fileName:'AfinalsStartlist.csv',withSeparator:false});
	}
	
	@action
	async createClasses()
	{
		var destinationEvent = this.args.destinationEvent;
		var destinationClasses = await destinationEvent.get('classes');

		await this.sprintTools.createClassesForHeat(destinationEvent, destinationClasses, this.AClassGroup, this.AAssignments);
	}
	
	@action
	async createEntries()
	{
		var destinationEvent = this.args.destinationEvent;
		var destinationEntries = await destinationEvent.get('entries');
		var destinationClasses = await destinationEvent.get('classes');

		// useNewBib = false because this file uses result.bib
		await this.sprintTools.createEntriesForHeat(destinationEvent, destinationEntries, destinationClasses, this.AClassGroup, this.AAssignments, this.startTimeA, false);
	}
	
	async calculateHeatAssignments()
	{
		var AAssignments = [];
		
		var S1ClassGroup = this.S1ClassGroup;
		var S2ClassGroup = this.S2ClassGroup;
		var S3ClassGroup = this.S3ClassGroup;
		
		if(	S1ClassGroup == null ||
			S2ClassGroup == null ||
			S3ClassGroup == null)
		{
			return;
		}
		
		var S1Results = [...(await S1ClassGroup.resultsSorted)];
		var S2Results = [...(await S2ClassGroup.resultsSorted)];
		var S3Results = [...(await S3ClassGroup.resultsSorted)];
		
		AAssignments.push(S1Results[0]);
		AAssignments.push(S2Results[0]);
		AAssignments.push(S3Results[0]);
		AAssignments.push(S1Results[1]);
		AAssignments.push(S2Results[1]);
		AAssignments.push(S3Results[1]);
		
		AAssignments[0].set('heatStartOrder',1);
		AAssignments[1].set('heatStartOrder',2);
		AAssignments[2].set('heatStartOrder',3);
		AAssignments[3].set('heatStartOrder',4);
		AAssignments[4].set('heatStartOrder',5);
		AAssignments[5].set('heatStartOrder',6);
		
		this.AAssignments = AAssignments;
	}
	
}
